import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { App } from './app/App';
import { queryClient } from './lib/queryClient';
import { setupServiceWorker } from './lib/serviceWorker';
import './styles/globals.css';

setupServiceWorker();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Elemento #root não encontrado em index.html');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: 'var(--glass-bg-strong)',
            border: '1px solid var(--color-hairline-strong)',
            color: 'var(--color-ink)',
            backdropFilter: 'blur(20px)',
            fontFamily: 'var(--font-body)',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
);
